// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ls-9";
export var arrowButtonContainer = "_ls-5";
export var arrowButtonIcon = "_ls-6";
export var carouselArrowButton = "_ls-2";
export var carouselElementContainer = "_ls-1";
export var currentSlide = "_ls-8";
export var left = "_ls-3";
export var otherSlide = "_ls-a";
export var productCarouselContainer = "_ls-0";
export var right = "_ls-4";
export var sliderOverflow = "_ls-7";